import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

/**
 * Handles the Google OAuth return. Emergent redirects to `/#session_id=...`.
 * We exchange the session_id (server-side) for our app session, then route home.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function AuthCallback() {
    const { googleSession } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;
        const params = new URLSearchParams((location.hash || "").replace(/^#/, ""));
        const sessionId = params.get("session_id");
        // Clear the fragment so the token isn't left in the URL/history.
        window.history.replaceState(null, "", window.location.pathname + window.location.search);
        if (!sessionId) { navigate("/", { replace: true }); return; }
        (async () => {
            const res = await googleSession(sessionId);
            if (res.ok) {
                toast.success(`Welcome${res.user?.name ? ", " + res.user.name.split(" ")[0] : ""}!`);
                navigate("/", { replace: true });
            } else {
                toast.error(res.error || "Google sign-in failed");
                navigate("/login", { replace: true });
            }
        })();
    }, [googleSession, navigate, location.hash]);

    return (
        <div className="min-h-[60vh] flex items-center justify-center text-[#a0a0a0]" data-testid="auth-callback">
            <div className="text-center">
                <div className="h-10 w-10 border-2 border-[#ff4500] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
                <div className="text-sm uppercase tracking-[0.2em]">Signing you in…</div>
            </div>
        </div>
    );
}
